import { render } from "./RsvpFormComponent.vue?vue&type=template&id=79980214&scoped=true"
import script from "./RsvpFormComponent.vue?vue&type=script&lang=js"
export * from "./RsvpFormComponent.vue?vue&type=script&lang=js"

import "./RsvpFormComponent.vue?vue&type=style&index=0&id=79980214&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79980214"]])

export default __exports__